// extracted by mini-css-extract-plugin
export default {"labelInfo":"ManualInstallmentPlan_labelInfo__athxI"};